import { Component, Input } from '@angular/core';
import { KpiBaseChartDto, KpiChartDataDto } from '../../../../services/chart/kpi-chart.service';

@Component({
  selector: 'chart-renderer-number',
  standalone: false,
  styleUrls: ['chart-renderer-number.component.scss'],
  template: `
    <div class="d-flex justify-content-around mt-5">
      <ng-container *ngFor="let data of chart.data; let i = index">
        <div class="text-center">
          <span class="fs-1"> {{ data.value }} </span>
          <hr class="mt-0" [ngClass]="colors[i % colors.length]" style="border: 1px solid; opacity: 1!important" />
          <div>
            {{ data.label | translate }}<span *ngIf="data.processKey"> ({{ data.processKey | translate }})</span>
          </div>
        </div>
        <div *ngIf="i < chart.data.length - 1" class="vr"></div>
      </ng-container>
    </div>
  `,
})
export class ChartRendererNumberComponent {
  @Input() chart!: KpiBaseChartDto;

  colors = ['gem-color-blue', 'gem-color-red-medium', 'gem-color-neon'];

  constructor() {}

  getLabel(key: string): string {
    return this.getData(key).label;
  }

  getValue(key: string): number {
    return this.getData(key).value;
  }

  private getData(key: string): KpiChartDataDto {
    return this.chart?.data.find(d => d.label == key);
  }
}
